















import Vue from 'vue';
import { ICustomSelectOption } from '../../../common/interfaces/shared.interface';

interface IProductVariantSelectComponent {
  selected: string | number;
}

export default Vue.extend({
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): IProductVariantSelectComponent {
    return {
      selected: ``,
    };
  },
  props: {
    defaultOption: {
      default: ``,
      type: String,
    },
    icon: {
      default: ``,
      type: String,
    },
    options: {
      default: () => [],
      type: Array as () => ICustomSelectOption[],
    },
    title: {
      default: ``,
      type: String,
    },
  },
  mounted(): void {
    this.selected = window._.find(this.options, { selected: true })?.optionValue ?? ``;
  },
  updated(): void {
    this.selected = window._.find(this.options, { selected: true })?.optionValue ?? ``;
  },
  methods: {
    changeValue(newValue: string | number): void {
      this.$emit(`change`, { newValue, oldValue: this.selected });
      this.selected = newValue;
    },
  },
});
